import React, { useState, useEffect } from "react";
import {
  CheckCircleIcon,
  XCircleIcon,
  ClockIcon,
} from "@heroicons/react/24/outline";

export default function LeaveRequests() {
  const [requests, setRequests] = useState([]);

  // Dummy data (replace with API later)
  useEffect(() => {
    setRequests([
      {
        id: 1,
        employee: "John Doe",
        type: "Sick Leave",
        from: "2025-01-10",
        to: "2025-01-12",
        status: "Pending",
      },
      {
        id: 2,
        employee: "Priya Sharma",
        type: "Casual Leave",
        from: "2025-01-15",
        to: "2025-01-15",
        status: "Approved",
      },
      {
        id: 3,
        employee: "Ravi Kumar",
        type: "Annual Leave",
        from: "2025-02-01",
        to: "2025-02-10",
        status: "Rejected",
      },
    ]);
  }, []);

  const getStatusBadge = (status) => {
    switch (status) {
      case "Approved":
        return (
          <span className="flex items-center gap-1 text-green-600 font-medium">
            <CheckCircleIcon className="w-5 h-5" /> Approved
          </span>
        );
      case "Rejected":
        return (
          <span className="flex items-center gap-1 text-red-600 font-medium">
            <XCircleIcon className="w-5 h-5" /> Rejected
          </span>
        );
      default:
        return (
          <span className="flex items-center gap-1 text-yellow-600 font-medium">
            <ClockIcon className="w-5 h-5" /> Pending
          </span>
        );
    }
  };

  return (
    <div>
      <h1 className="text-3xl font-semibold mb-6">Leave Requests</h1>

      <div className="bg-white p-6 rounded-xl shadow-md">
        <table className="w-full border-collapse">
          <thead>
            <tr className="text-left bg-gray-100">
              <th className="p-3 font-semibold text-gray-700">Employee</th>
              <th className="p-3 font-semibold text-gray-700">Leave Type</th>
              <th className="p-3 font-semibold text-gray-700">From</th>
              <th className="p-3 font-semibold text-gray-700">To</th>
              <th className="p-3 font-semibold text-gray-700">Status</th>
              <th className="p-3 font-semibold text-gray-700 text-right">Action</th>
            </tr>
          </thead>

          <tbody>
            {requests.map((req) => (
              <tr key={req.id} className="border-b hover:bg-gray-50">
                <td className="p-3">{req.employee}</td>
                <td className="p-3">{req.type}</td>
                <td className="p-3">{req.from}</td>
                <td className="p-3">{req.to}</td>
                <td className="p-3">{getStatusBadge(req.status)}</td>

                <td className="p-3 text-right">
                  {req.status === "Pending" && (
                    <div className="flex justify-end gap-2">
                      <button className="bg-green-600 text-white px-4 py-1 rounded-md hover:bg-green-700">
                        Approve
                      </button>
                      <button className="bg-red-600 text-white px-4 py-1 rounded-md hover:bg-red-700">
                        Reject
                      </button>
                    </div>
                  )}

                  {req.status !== "Pending" && (
                    <span className="text-gray-500 italic">No actions</span>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
